__turbopack_context__.v({
  "adminButton": "SchoolFeedBlock-module-scss-module__PFNIbG__adminButton",
  "adminButtonContainer": "SchoolFeedBlock-module-scss-module__PFNIbG__adminButtonContainer",
  "blocksBackgroundColor": "SchoolFeedBlock-module-scss-module__PFNIbG__blocksBackgroundColor",
  "blocksFontColor": "SchoolFeedBlock-module-scss-module__PFNIbG__blocksFontColor",
  "container": "SchoolFeedBlock-module-scss-module__PFNIbG__container",
  "feedHeader": "SchoolFeedBlock-module-scss-module__PFNIbG__feedHeader",
  "feedHeaderSmallBlock": "SchoolFeedBlock-module-scss-module__PFNIbG__feedHeaderSmallBlock",
  "secondaryNavBackgroundColor": "SchoolFeedBlock-module-scss-module__PFNIbG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "SchoolFeedBlock-module-scss-module__PFNIbG__themeBackgroundColor",
  "themeFontColor": "SchoolFeedBlock-module-scss-module__PFNIbG__themeFontColor",
  "toggleButtonContainer": "SchoolFeedBlock-module-scss-module__PFNIbG__toggleButtonContainer",
  "toggleButtons": "SchoolFeedBlock-module-scss-module__PFNIbG__toggleButtons",
});
